import { api } from '../api';

export type BuscarResultado = 'no-encontrado' | 'no-titular' | 'unico' | 'multiple';

export interface CandidatoBusqueda {
  asociadoId: string;
  nombres: string;
  apellSolt: string;
  documento: string;
  fechaNacimiento?: string;
  parentesco?: string;
  /** N° de socio real de Binary; fallback al webid. Solo viene en 'unico'. */
  numeroSocio?: string;
  /** Plan actual en Binary EN VIVO. Solo viene en 'unico' (confirmación). */
  planActual?: 'MS1' | 'MS2' | 'otro' | null;
}

/**
 * Lo que devuelve el resumen de la oferta: beneficios, cuánto sale y si el socio
 * puede pasarse. **Ningún dato personal.**
 *
 * Hasta el 2026-08-27 traía una lista `integrantes` con nombre, DNI, fecha de
 * nacimiento y N° de socio de cada familiar, y la pantalla los mostraba en
 * tarjetas. Como `/mejora-plan` es pública y se entra con un DNI, eso exponía
 * los datos de toda la familia a cualquiera que conociera el documento del
 * titular. Se quitó del backend (no solo de la vista). Del grupo queda solo
 * `costo.cantidad`, que es lo que explica el precio.
 */
export interface ResumenOferta {
  beneficios: string[];
  costo: { cantidad: number; totalConIva: number; subtotalSinIva: number; vigencia: string };
  elegible: boolean;
  motivoNoElegible?: string;
  /** `MS2_CARENCIA` si el motivo es la carencia de 12 meses: se avisa con un pop-up. */
  codigoNoElegible?: string;
}

export interface IniciarPagoResultado {
  modo: 'redirect' | 'directo';
  estado: string;
  urlCheckout?: string;
  referenciaExterna?: string;
  monto?: number;
  motivoRechazo?: string;
}

export async function buscarSocioPorDni(
  dni: string,
): Promise<{ resultado: BuscarResultado; candidatos: CandidatoBusqueda[] }> {
  const { data } = await api.post('/autogestion-ms2/buscar', { dni });
  return data;
}

export async function getResumenOferta(asociadoId: string): Promise<ResumenOferta> {
  const { data } = await api.get<ResumenOferta>(`/autogestion-ms2/resumen/${asociadoId}`);
  return data;
}

export async function iniciarPagoMs2(
  asociadoId: string,
  origen?: string,
): Promise<IniciarPagoResultado> {
  const { data } = await api.post<IniciarPagoResultado>(
    `/autogestion-ms2/${asociadoId}/iniciar-pago`,
    { origen },
  );
  return data;
}
